const ButtonElement = ({
    text,
    onClick,
    type = "button",
    variant = "primary",
    disabled = false,
    loading = false,
    cssClass = ""
}) => <button
    className={`btn ${variant} ${cssClass} ${disabled || loading ? "disabled" : ""}`}
    onClick={!loading ? onClick : undefined}
    type={type}
    disabled={disabled || loading}>
        {loading ? <span className="spinner-grow spinner-grow-sm"></span> : text}
    </button>

export default ButtonElement;